export type StackItem = {
  label: string
  title: string
  description: string
  value: number
  bonus: boolean
}

export const stackItems: StackItem[] = [
  {
    label: 'Producto principal',
    title: 'Guía Maestra: Método Híbrido 2.0',
    description: 'El manual de 60 páginas con toda la periodización explicada paso a paso.',
    value: 15000,
    bonus: false,
  },
  {
    label: 'Producto principal',
    title: 'Plan de Entrenamiento 12 Semanas',
    description: 'Día por día: sesiones de fuerza + rodajes de carrera perfectamente coordinados.',
    value: 20000,
    bonus: false,
  },
  {
    label: 'Bono 1',
    title: 'Calculadora Automática de Ritmos y Pesos',
    description: 'Planilla de Excel que calcula tus cargas y ritmos objetivo en segundos.',
    value: 9000,
    bonus: true,
  },
  {
    label: 'Bono 2',
    title: 'Guía de Nutrición Híbrida',
    description: 'Cómo aplicar carb-loading para rendir en fuerza y resistencia el mismo día.',
    value: 7500,
    bonus: true,
  },
  {
    label: 'Bono 3',
    title: 'Rutina "Movilidad Blindada"',
    description: 'Protocolo anti-lesiones para rodillas, cadera y tobillos bajo doble impacto.',
    value: 6000,
    bonus: true,
  },
  {
    label: 'Bono 4',
    title: 'Tech-Mastery',
    description: 'Configuración exacta de tu Garmin / Apple Watch para medir lo que importa.',
    value: 5000,
    bonus: true,
  },
  {
    label: 'Bono 5',
    title: 'Manual de Suplementación de Élite',
    description: 'Qué tomar, cuánto y cuándo. Sin humo ni marcas patrocinadas.',
    value: 5000,
    bonus: true,
  },
]

export const totalValue = 67500
export const price = 17990

export const CHECKOUT_URL = 'https://hybrido-fit.impultienda.ar/checkout'

export const painPoints: string[] = [
  'Entrenás piernas el lunes y querés correr el martes, pero tus rodillas no dan más.',
  'Intentás seguir una rutina de culturismo y un plan de running al mismo tiempo, y terminás lesionado o estancado.',
  'Tu cuerpo vive en un estado de fatiga constante y tus marcas no suben en ningún lado.',
]

export type Outcome = {
  title: string
  description: string
}

export const outcomes: Outcome[] = [
  {
    title: 'Fuerza Real',
    description: 'Mantené y aumentá tus marcas en Sentadilla, Peso Muerto y Press.',
  },
  {
    title: 'Resistencia de Acero',
    description: 'Bajá tus tiempos en 5K y 10K con una técnica de carrera eficiente.',
  },
  {
    title: 'Estética Funcional',
    description: 'Lográ el cuerpo de un atleta "Hybrid": definido, fuerte y capaz.',
  },
  {
    title: 'Cero Lesiones',
    description: 'Protocolos de movilidad específicos para proteger tus articulaciones del doble impacto.',
  },
]

export const formatARS = (amount: number): string =>
  `$${amount.toLocaleString('es-AR')}`
